export const withoutHandoutScores = (value) => String(value || "").replace(/[（(]\s*(?:(?:每(?:小?題|格|空)|共|合計|總分|配分)\s*)?(?:\*\*\s*)?\d+(?:\.\d+)?\s*(?:\*\*\s*)?分(?:\s*[,，、]\s*(?:(?:共|合計|每(?:小?題|格|空))\s*)?(?:\*\*\s*)?\d+(?:\.\d+)?\s*(?:\*\*\s*)?分)*\s*[）)]/g, "").trim();
export const withoutSourceSignatures = (value) => String(value || "")
  .replace(/(?:羿宏|彥丞|uncounted)(?:[、，,／/|｜\s]+|$)/gi, "")
  .replace(/^[ 、，,／/|｜]+|[ 、，,／/|｜]+$/g, "").replace(/\s+/g, " ").trim();
